import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingDisplayService {

  totalRequests = 0;
  showSpinner$: BehaviorSubject<boolean> = new BehaviorSubject(false);

  constructor() {
  }

  addRequest() {
    this.totalRequests++;
    setTimeout(() => this.showSpinner$.next(true));
  }

  removeRequest() {
    this.totalRequests--;
    if (this.totalRequests === 0) {
      setTimeout(() => this.showSpinner$.next(false));
    }
  }
}
